export enum UserRole {
  Customer = "customer",
  Writer = "writer",
}
